import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { corporateCMSApi, post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useCommercialLeasing } from "../BusinessOppurtunities.hook";
import { fields } from "../constants";

export const AddEditCommercialLeasingOpportunities = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const subModule = pathParts[pathParts.indexOf("commercialLeasingOpportunities") + 1] || "";
  const [records, setRecords] = useState<any[]>([]);
  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useCommercialLeasing(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);
  const getRecords = () => {
    let url = `/api/get-commercial-details/get-all-fields`;
    corporateCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          if (subModule === "retailOutletList") {
            envelopes = envelopes.filter((item: any) => item?.field_pagename_en === "retail-outlet");
          } else if (subModule === "foodAndBeverageList") {
            envelopes = envelopes.filter((item: any) => item?.field_pagename_en === "food-and-beverage-outlet");
          } else if (subModule === "serviceOutletList") {
            envelopes = envelopes.filter((item: any) => item?.field_pagename_en === "service-outlet");
          } else if (subModule === "othersList") {
            envelopes = envelopes.filter(
              (item: any) =>
                !["retail-outlet", "food-and-beverage-outlet", "service-outlet"].includes(item?.field_pagename_en)
            );
          }

          setRecords(envelopes);
        }
      })
      .catch((err) => {
        setRecords([]);
      });
  };
  useEffect(() => {
    getRecords();
  }, []);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      title: dataById ? decodeHTML(dataById.payload.title) : editData ? decodeHTML(editData?.title) : "",
      field_tender_category_ms: dataById
        ? decodeHTML(dataById.payload.field_tender_category_ms)
        : editData
          ? decodeHTML(editData.field_tender_category_ms)
          : "",
      field_tender_category_zh: dataById
        ? decodeHTML(dataById.payload.field_tender_category_zh)
        : editData
          ? decodeHTML(editData?.field_tender_category_zh)
          : "",
      field_omd_number_en: dataById
        ? decodeHTML(dataById.payload.field_omd_number_en)
        : editData
          ? decodeHTML(editData?.field_omd_number_en)
          : "",
      field_omd_number_ms: dataById
        ? decodeHTML(dataById.payload.field_omd_number_ms)
        : editData
          ? decodeHTML(editData.field_omd_number_ms)
          : "",
      field_omd_number_zh: dataById
        ? decodeHTML(dataById.payload.field_omd_number_zh)
        : editData
          ? decodeHTML(editData?.field_omd_number_zh)
          : "",
      field_airport_en: dataById
        ? decodeHTML(dataById.payload.field_airport_en)
        : editData
          ? decodeHTML(editData?.field_airport_en)
          : "",
      field_airport_ms: dataById
        ? decodeHTML(dataById.payload.field_airport_ms)
        : editData
          ? decodeHTML(editData?.field_airport_ms)
          : "",
      field_airport_zh: dataById
        ? decodeHTML(dataById.payload.field_airport_zh)
        : editData
          ? decodeHTML(editData?.field_airport_zh)
          : "",
      field_leasing_en: dataById
        ? decodeHTML(dataById.payload.field_leasing_en)
        : editData
          ? decodeHTML(editData?.field_leasing_en)
          : "",
      field_leasing_ms: dataById
        ? decodeHTML(dataById.payload.field_leasing_ms)
        : editData
          ? decodeHTML(editData?.field_leasing_ms)
          : "",
      field_leasing_zh: dataById
        ? decodeHTML(dataById.payload.field_leasing_zh)
        : editData
          ? decodeHTML(editData?.field_leasing_zh)
          : "",
      field_tenancy_link_en: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_tenancy_link_en.pdf",
              status: "done",
              url: dataById?.payload?.field_tenancy_link_en,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_tenancy_link_en.pdf",
              status: "done",
              url: editData?.field_tenancy_link_en,
            },
          ]),
      field_tenancy_link_ms: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_tenancy_link_ms.pdf",
              status: "done",
              url: dataById?.payload?.field_tenancy_link_ms,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_tenancy_link_ms.pdf",
              status: "done",
              url: editData?.field_tenancy_link_ms,
            },
          ]),
      field_tenancy_link_zh: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_tenancy_link_zh.pdf",
              status: "done",
              url: dataById?.payload?.field_tenancy_link_zh,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_tenancy_link_zh.pdf",
              status: "done",
              url: editData?.field_tenancy_link_zh,
            },
          ]),
      field_tender_priority: dataById
        ? decodeHTML(dataById.payload.field_tender_priority)
        : editData
          ? decodeHTML(editData.field_tender_priority)
          : null,
      field_tender_priority_ms: dataById
        ? decodeHTML(dataById.payload.field_tender_priority_ms)
        : editData
          ? decodeHTML(editData?.field_tender_priority_ms)
          : null,
      field_tender_priority_zh: dataById
        ? decodeHTML(dataById.payload.field_tender_priority_zh)
        : editData
          ? decodeHTML(editData?.field_tender_priority_zh)
          : null,
      field_leasing_order_sequence: dataById
        ? decodeHTML(dataById.payload.field_leasing_order_sequence)
        : editData
          ? decodeHTML(editData?.field_leasing_order_sequence)
          : "",
      field_pagename_en: dataById
        ? decodeHTML(dataById.payload.field_pagename_en)
        : editData
          ? decodeHTML(editData?.field_pagename_en)
          : "",
      field_opening_date: dataById
        ? decodeHTML(dataById.payload.field_opening_date)
        : editData
          ? decodeHTML(editData?.field_opening_date)
          : "",
      field_closing_date: dataById
        ? decodeHTML(dataById.payload.field_closing_date)
        : editData
          ? decodeHTML(editData?.field_closing_date)
          : "",
      published: dataById
        ? decodeHTML(dataById.payload?.published)
        : editData
          ? decodeHTML(editData?.published)
          : false,
    },
    fields: fields?.commercialLeasingOpportunitiesList?.map((field: any) => {
      if (field.name === "field_leasing_order_sequence") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;
              const existingRecord = records.find((record: any) => {
                return (
                  toInteger(record[field.name]) === toInteger(value) &&
                  record.id !== (editData?.id || dataById?.payload?.id)
                );
              });
              return !existingRecord || `${field.label || field.name} already exists`;
            },
          },
        };
      }
      return field;
    }),
  };
  const getPageName = (subModule: string) => {
    switch (subModule) {
      case "retailOutletList":
        return "retail-outlet";
      case "othersList":
        return "others";
      case "serviceOutletList":
        return "service-outlet";
      case "foodAndBeverageList":
        return "food-and-beverage-outlet";
      default:
        return "";
    }
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image", "field_tenancy_link_zh", "field_tenancy_link_ms", "field_tenancy_link_en"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Business Opportunities",
      subModule: `commercialLeasingOpportunitiesList_${subModule}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Business Opportunities_Commercial Leasing Opportunities",
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
        field_pagename_en: getPageName(subModule),
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} ${subModule
        ?.replace(/([A-Z])/g, " $1") // adds space before capitals
        ?.replace(/^./, (s) => s.toUpperCase()) // capitalize first letter
        .trim()}`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${corporateHost}/api/commercial-leasing-opportunity/${editData?.id || dataById?.payload?.id}`
              : `${corporateHost}/api/create/commercial-leasing-opportunity`,
            query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Business Opportunities"
      />
    </ContentWrapper>
  );
};
